import { createReducer } from "@reduxjs/toolkit";

import { TYPES } from "../../common/constants";
import moment from 'moment';
const startLoadingDownloadServiceRequestCSV = () => {
  return {
    loading: true,
    loadingDone: false,
    serviceRequestList: [],
  };
};
const stopLoadingDownloadServiceRequestCSV = (csvExport) => {
  return {
    ...csvExport,
    ...{
      loading: false,
      loadingDone: false,
    },

    // serviceRequestList: csvExport.serviceRequestList
  };
};

const fetchedDownloadServiceRequestCSV = (csvExport, { payload }) => {
  let covertedSRs = [];
  for (var i = 0; i < payload.length; i++) {
    let tmp = payload[i];
    let attachment = tmp.attachment;
    let tmpAttachments = "";
    if (attachment && attachment.length > 0) {
      let parsedAttachement = JSON.parse(attachment);
      if (parsedAttachement && parsedAttachement.length > 0) {
        parsedAttachement = parsedAttachement.filter((a) => a !== null);
        parsedAttachement = parsedAttachement.filter((a) => a !== "undefined");
        let filterParsedAttachments = parsedAttachement.filter(
          (a) => a.indexOf("base64") === -1
        );
        tmpAttachments = JSON.stringify(filterParsedAttachments);
      }
    } else {
      tmpAttachments = null;
    }
    if(!!tmpAttachments)
    payload[i].attachment = JSON.parse(tmpAttachments);

    if(!!tmp.createdDateSt)
    payload[i].createdDateSt=moment(tmp.createdDateSt).format('MM-DD-YYYY');

    if(!!tmp.scheduledAt)
    payload[i].scheduledAt=moment(tmp.scheduledAt).format('MM-DD-YYYY');

    if(!!tmp.lastUpdatedst)
    payload[i].lastUpdatedst=moment(tmp.lastUpdatedst).format('MM-DD-YYYY');

    if(!!tmp.approvedDatest)
     payload[i].approvedDatest=moment(tmp.approvedDatest).format('MM-DD-YYYY');

     if(!!tmp.underReviewDatest)
     payload[i].underReviewDatest=moment(tmp.underReviewDatest).format('MM-DD-YYYY');

     if(!!tmp.assignedDatest)
     payload[i].assignedDatest=moment(tmp.assignedDatest).format('MM-DD-YYYY');

     if(!!tmp.inProgressDatest)
     payload[i].inProgressDatest=moment(tmp.inProgressDatest).format('MM-DD-YYYY');

     if(!!tmp.enRouteDatest)
     payload[i].enRouteDatest=moment(tmp.enRouteDatest).format('MM-DD-YYYY');

     if(!!tmp.onHoldDatest)
     payload[i].onHoldDatest=moment(tmp.onHoldDatest).format('MM-DD-YYYY');
   
     if(!!tmp.declinedDatest)
     payload[i].declinedDatest=moment(tmp.declinedDatest).format('MM-DD-YYYY');

     if(!!tmp.scheduleDatest)
     payload[i].scheduleDatest=moment(tmp.scheduleDatest).format('MM-DD-YYYY');

     if(!!tmp.resolvedDatest)
     payload[i].resolvedDatest=moment(tmp.resolvedDatest).format('MM-DD-YYYY');

     if(!!tmp.closedDatest)
     payload[i].closedDatest=moment(tmp.closedDatest).format('MM-DD-YYYY');

     if(!!tmp.oneYearWarrantyDatest)
     payload[i].oneYearWarrantyDatest=moment(tmp.oneYearWarrantyDatest).format('MM-DD-YYYY');
    
    /**
     * Modified by: Sai Prasad
     * Modified on: 23/12/2022
     * Jira ticket: JUN-3553
     * Comment: Added homeowner information in csv download.
     */

    if(tmp.homeOwners && tmp.homeOwners.id) {
      let hoDetails = tmp.homeOwners;
      let contactInfo = hoDetails.email + ',' + hoDetails.phone;

      if(hoDetails.address && hoDetails.address.id) {
        if(hoDetails.address.addressLine1) {
          contactInfo = contactInfo.concat(',' + hoDetails.address.addressLine1);
        }
        if(hoDetails.address.addressLine2) {
          contactInfo = contactInfo.concat(',' + hoDetails.address.addressLine2 );
        }
        if(hoDetails.address.city) {
          contactInfo = contactInfo.concat(',' + hoDetails.address.city );
        }
        if(hoDetails.address.province) {
          contactInfo = contactInfo.concat(',' + hoDetails.address.province );
        }
        if(hoDetails.address.postalCode) {
          contactInfo = contactInfo.concat(',' + hoDetails.address.postalCode );
        }
      }
      payload[i].homeOwnerName = hoDetails?.firstname + ' ' + hoDetails?.lastname;
      payload[i].homeOwnerContactInfo = contactInfo;
      payload[i].homeOwnerEmail = hoDetails?.email;
     
    } else {
      payload[i].homeOwnerName = '';
      payload[i].homeOwnerContactInfo = '';
      payload[i].homeOwnerEmail = '';
    }
  }
  return {
    loading: csvExport.loading,
    loadingDone: true,
    serviceRequestList: payload,
  };
};

const clearLoadingDownloadServiceRequestCSV = () => {
  return {
    loading: false,
    loadingDone: false,
    serviceRequestList: [],
  };
};

const setMainServiceRequestPDFDownloadList = (csvExport,{ payload }) => {
  return {
    ...csvExport,
    ...{
      loading: false,
      loadingDone: false,
      serviceRequestPDFDownloadList:payload
    },
  };
};
const initialState = {
  loading: false,
  loadingDone: false,
  serviceRequestList: [],
  serviceRequestPDFDownloadList:[]
};
export default createReducer(initialState, {
  [TYPES.START_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV]:
    startLoadingDownloadServiceRequestCSV,
  [TYPES.STOP_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV]:
    stopLoadingDownloadServiceRequestCSV,
  [TYPES.FETCHED_DOWNLOAD_SERVICE_REQUEST_LIST_CSV_DONE]:
    fetchedDownloadServiceRequestCSV,
    [TYPES.CLEAR_LOADING_DOWNLOAD_SERVICE_REQUEST_LIST_CSV]: clearLoadingDownloadServiceRequestCSV,
    [TYPES.SET_MAIN_SERVICE_REQUEST_PDF_DOWNLOAD_LIST]:setMainServiceRequestPDFDownloadList
});
